import { ChangeEvent, InputHTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import HomeSearchIco from "../../../../assets/icons/search-input-ico.png";

interface ISearchBoxProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  icon?: string;
  className?: string;
  style?: React.CSSProperties;
  value?: string;
  name?: string;
}

const SearchBox: React.FC<ISearchBoxProps> = ({
  onChange,
  placeholder,
  icon = HomeSearchIco,
  className,
  style,
  defaultValue,
  value,
  name = "search",
  ...props
}) => {
  const { t } = useTranslation();
  const resolvedPlaceholder = placeholder ?? t("common.searchPlaceholder");

  return (
    <SearchBoxContainer className={className} style={style}>
      <IconContainer>
        <img
          src={icon}
          alt="search icon"
          style={{ height: "18px", width: "18px" }}
        />
      </IconContainer>
      <SearchInput
        className="w-full md:w-36 xl:w-72"
        placeholder={resolvedPlaceholder}
        autoComplete="off"
        name={name}
        onChange={onChange}
        defaultValue={defaultValue}
        value={value}
        {...props}
      />
    </SearchBoxContainer>
  );
};

export default SearchBox;

const SearchBoxContainer = styled.div`
  height: 32px;
  background: rgba(156, 176, 196, 0.2);
  border: 1px solid rgba(156, 176, 196, 0.25);
  color: white;
  width: 280px;
  display: flex;
  align-items: center;
  border-radius: 7px;

  &:focus-within {
    border: 2px solid rgba(156, 176, 196, 0.25);
  }

  & > input {
    width: calc(100% - 45px);
  }

  & > div {
    width: 45px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const IconContainer = styled.div`
  width: 45px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SearchInput = styled.input`
  background: transparent;
  height: 100%;
  width: 100%;
  font-size: 15px;
  font-weight: 400;
  padding: 14px 0px;
  border-radius: 10px;
  &::placeholder {
    color: white;
    opacity: 1;
  }
`;
